module.exports = __webpack_public_path__ + "static/media/ding.b65c666f.mp3";